import { Component, Inject, ComponentFactoryResolver, ViewChild, ViewContainerRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { COMPONENT_REGISTRY } from '../../window/providers';
import { ComponentMap } from '../../window/interfaces';
import { insensitiveEqual } from '../../shared/utils';
import { formRegistryError } from '../../shared/exceptions';

@Component({
  selector: 'bm-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss']
})
export class StaticPageComponent implements OnInit {

  @ViewChild('vcRef', {read: ViewContainerRef, static: true})
  vcRef: ViewContainerRef;


  constructor(
    private activeRoute: ActivatedRoute,
    private factoryResolver: ComponentFactoryResolver,
    @Inject(COMPONENT_REGISTRY) private registry: ComponentMap[],
  ) {}


  ngOnInit() {
    this.activeRoute.paramMap.subscribe(paramMap => {
      const formName = paramMap.get('formName');

      const formMap = this.registry.find(map => insensitiveEqual(formName, map.name));
      if (!formMap) {
        formRegistryError(formName);
      }
      const factory = this.factoryResolver.resolveComponentFactory(formMap.component);
      this.vcRef.clear();
      this.vcRef.createComponent(factory);
    });

  }

}
